<template>
  <nav class="flex items-center justify-between flex-wrap bg-teal-500 p-6">
    <div class="flex items-center flex-shrink-0 text-white mr-6">
      <a
        href="/"
        class="inline-block text-base px-4 py-2 leading-none border rounded text-primary border-white hover:border-transparent hover:text-teal-500 hover:bg-white mt-4 lg:mt-0"
      >&laquo; 返回</a>
    </div>
    <div class="w-full block flex-grow lg:flex lg:items-center lg:w-auto">
      <div class="text-sm lg:flex-grow">
        <div class="font-semibold text-4xl tracking-tight text-white">{{ card }} Flashcards</div>
      </div>
      <!-- <div>
        <button 
          class="inline-block text-base text-white px-4 py-2 leading-none border rounded text-primary border-white hover:border-transparent hover:text-teal-500 hover:bg-white mt-4 lg:mt-0"
        >
          重头开始
        </button>
      </div>-->
    </div>
  </nav>
</template>

<script>
export default {
  name: "Nav",
  computed: {
    card() {
      return this.$route.params.card;
    }
  },
  mounted() {
    this.$ga.page(this.card);
  },
  methods: {
    track() {
      this.$ga.page(this.card);
    }
  }
};
</script>
